// extracted by mini-css-extract-plugin
export default {"loginOuter":"ResgisterModal_loginOuter__fxGir"};